import React from 'react';
import { usePermissions } from '../../contexts/PermissionsContext';
import PosPageFull from './PosPageFull';
import PosPageStaff from './PosPageStaff';
import './PosPage.css';

/**
 * POS Page Wrapper - mostra interfaccia completa per admin o semplificata per staff
 */
const PosPage: React.FC = () => {
    const { isStaff, isTenantAdmin, permissions, loading } = usePermissions();

    if (loading) {
        return (
            <div className="pos-loading">
                <div>Caricamento POS...</div>
            </div>
        );
    }

    // Se è staff senza permessi avanzati, mostra versione semplificata
    const useStaffVersion = isStaff && !permissions.staffCanManageCashSessions && !permissions.staffCanViewPosStatistics;

    if (useStaffVersion) {
        return <PosPageStaff />;
    }

    // Altrimenti mostra versione completa (admin o staff con permessi)
    return <PosPageFull />;
};

export default PosPage;
